/* @flow strict */

import * as React from 'react';

type PropsType = {
  gridType: number,
  setGridType: (number) => void
};

const EventPageHeader = ({ gridType, setGridType }: PropsType): React.Element<typeof React.Fragment> => {
  return (
    <h3 className="title">
      <span>Sparxo Events</span>
      <ul
        style={{
          gridTemplateColumns: 'repeat(3, 1fr)'
        }}
      >
        <li
          className={`${gridType === 1 ? 'active' : ''}`}
          onClick={() => {
            setGridType(1);
          }}
        >
          <i
            className="glyphicon glyphicon-th-large"
            style={{
              position: 'relative',
              left: '1px'
            }}
          />
        </li>
        <li
          className={`${gridType === 2 ? 'active' : ''}`}
          onClick={() => {
            setGridType(2);
          }}
        >
          <i className="glyphicon glyphicon-menu-hamburger" />
        </li>
        <li
          className={`${gridType === 3 ? 'active' : ''}`}
          onClick={() => {
            setGridType(3);
          }}
        >
          <i className="glyphicon glyphicon-signal" />
        </li>
      </ul>
    </h3>
  );
};

export default EventPageHeader;
